// H5 referral module routes.
import type { RouteRecordRaw } from "vue-router";

export const referralRoutes: RouteRecordRaw[] = [
  {
    path: "/referrals/customers",
    name: "referral-customers",
    component: () => import("@/modules/referral/pages/MyCustomersPage.vue"),
  },
  {
    path: "/referrals/team",
    name: "referral-team",
    component: () => import("@/modules/referral/pages/TeamOverviewPage.vue"),
  },
  {
    path: "/referrals/rebates",
    name: "referral-rebates",
    component: () => import("@/modules/rebate/pages/MyRebatesPage.vue"),
  },
  {
    path: "/referrals/rebates/:rebateId",
    name: "rebate-detail",
    component: () => import("@/modules/rebate/pages/RebateDetailsPage.vue"),
  },
  {
    path: "/referrals",
    name: "referral",
    component: () => import("@/modules/referral/pages/ReferralCenterPage.vue"),
  },
];
